import React, { FC, useMemo } from "react";
import { GeometryType } from "@evergis/api";
import { Icon, IconTypesKeys } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { FieldValue } from "../styled";
import { SourceDescription, SourceDescriptionName } from "./styled";

interface TableSourceDescriptionProps {
  tableName?: string;
  layerName?: string;
  geometryType?: GeometryType;
}

export const getGeomIcon = (type: GeometryType | "raster"): IconTypesKeys => `geom_${type}` as IconTypesKeys;

export const TableSourceDescription: FC<TableSourceDescriptionProps> = ({ tableName, layerName, geometryType }) => {
  const { t } = useTranslation("dialogs");
  const tableError = !tableName && !!layerName;
  const icon = tableError ? "warning" : getGeomIcon(geometryType);
  const description = tableError ? layerName : tableName;

  const fieldName = useMemo(
    () => (tableError ? t("dialogComponents.tableUnavailable") : t("dialogComponents.table")),
    [tableError, t],
  );

  return (
    <FieldValue
      field={<SourceDescriptionName error={tableError}>{fieldName}</SourceDescriptionName>}
      value={
        <>
          <Icon kind={icon} error={tableError} />
          <SourceDescription error={tableError}>{description}</SourceDescription>
        </>
      }
    />
  );
};
